import { motion } from "framer-motion";

const initial = { opacity: 0, y: 40 };
const whileInView = { opacity: 1, y: 0 };
const viewport = { once: true, margin: "-80px" };

export function FadeUp({ children, delay = 0, className = "", ...props }) {
  return (
    <motion.div
      className={className}
      initial={initial}
      whileInView={whileInView}
      viewport={viewport}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
      {...props}
    >
      {children}
    </motion.div>
  );
}
